import React from "react";
import { AmlExplanatoryNotes2 } from "../../reportSections/aml/amlExplanatoryNotes";
import { apiGet, apiPost } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from "../../common/loadingComponent";
import { connect } from "react-redux";
import { isNullOrUndefined } from "../../../store/storeFunctions";
import { popupActions } from '../../../store/popupStore';
import { Redirect } from 'react-router';
import { registrySearchActions, REGISTRY, getDataHash, SEARCH_TYPE } from '../../../store/ceeSearchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import AmlGlobalEval from "../../reportSections/aml/amlGlobalEval";
import AmlRelatedSubjectsEval from "../../reportSections/aml/amlRelatedSubjectsEval";
import AmlReportDateInformation from "./amlReportDateInformation";
import AmlReportStatus, { amlReportStatus } from "../../reportSections/aml/amlReportStatus";
import classnames from "classnames";
import IdentData from "../../reportSections/identData";
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import OldStyleSection from '../../common/oldStyleSection';
import SvgRefresh from "../../../img/icons/Refresh";
import { hasPermission } from '../../../store/apiWrapper';

class AmlCompany extends React.Component {
    state = {
        data: null,
        dataHash: null,
        loading: false,
        responseData: null,
        refreshReqInit: false,
        amlTree: false
    }

    render() {
        if (this.state.loading)
            return <Circles />;

        if (isNullOrUndefined(this.state.data))
            return <NoDataComponent />;

        if (this.state.refreshReqInit && this.props.cee[REGISTRY.aml].requestResult)
            return <Redirect to='/search/aml/results' />;

        var agentLanguage = this.props.user.authentication.profile.agentLanguage;

        return (
            <>
                {this.state.data !== null && this.state.loading === false && this.renderContent(this.props.asReport === true)}
                <div className="disclaimer-wrapper">
                    <div className="disclaimer-gray"><Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} /></div>
                </div>
            </>
        )
    }

    renderContent(asReport) {
        if (asReport) {
            return (
                <>
                    {this.renderErrors()}
                    {this.areAvailable(this.state.data) && this.renderInfo()}
                    <div className={classnames("card", { "card-special": !this.areAvailable(this.state.data) })}>
                        <div className="card-body">
                            <AmlReportStatus
                                data={this.state.data}
                                dataHash={this.state.dataHash}
                                onNotRequested={() => this.requestData()}
                                onInProgress={() => this.getData()}
                                asReport={this.props.asReport}
                                updateData={() => this.updateData()}
                                setAmlTreeValue={(amlTree) => this.setState({ amlTree: amlTree })}
                            >
                                {this.renderAmlData()}
                            </AmlReportStatus>
                        </div>
                    </div>
                </>
            )
        }

        return (
            <>
                {this.renderErrors()}
                {this.renderInfo()}
                <div className="card">
                    <div className="card-body">
                        {this.renderAmlData()}
                    </div>
                </div>
            </>
        );
    }

    renderInfo = () => {
        return (
            <>
                <AmlReportDateInformation inserted={this.state.data.insertedFormated} completed={this.state.data.completedFormated} profile={this.state.data.amlProfileName} />
                <div className="alone-section">
                    <OldStyleSection name={this.props.translate("Alerts.Identification")} hasData={this.state.data.basicInformations} isOpen isBold>
                        <div className="card">
                            <div className="card-body">
                                <IdentData data={this.state.data.basicInformations} />
                            </div>
                        </div>
                    </OldStyleSection>
                </div>
            </>
        );
    }

    renderAmlData() {
        return (
            <div className="aml-available">
                <div className="columns">
                    <div className="column is-narrow" style={{ display: "flex", alignItems: "center" }}>
                        <SvgRefresh className="refresh-icon" />
                        <div style={{ justifyContent: "flex-start" }} className="link-internal" onClick={() => this.updateData()}>
                            <Translate id="Report.Aml.UpdateData" />
                        </div>
                    </div>
                </div>
                <AmlGlobalEval data={this.state.data} decision={this.state.data.decision} />
                {!this.isPath() &&
                    <>
                        <AmlRelatedSubjectsEval finalOwnerNegativeInfoText={this.state.data.finalOwnerNegativeInfoText} fontAwesomeIconName="chart-line" profiles={this.state.data.amlRelationProfiles} subjects={this.state.data.subjects} isSection={true} methodology={this.state.data.methodology} share={this.state.data.share} hideRatioFilter={false} />
                        <AmlExplanatoryNotes2 data={this.state.data} methodology={true} />
                    </>
                }
            </div >
        );
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (!isNullOrUndefined(this.state.data) && !isNullOrUndefined(this.state.data.entityId) && isNullOrUndefined(this.props.entity.entityInfos[this.state.data.entityId])) {
            this.props.ensureEntityInfo(this.state.data.entityId);
        }
        if (prevProps.match.params.id != this.props.match.params.id) {
            this.getData();
        }
    }

    requestData() {
        this.setState({ loading: true });
        this.props.setResultsRequestParams(REGISTRY.aml, null);

        if (this.props.asReport === true) {
            apiPost(`${window.babylonApiUrl}/api/report/${this.props.match.params.id}/aml-info-check`, null, null,
                () => this.getData(),
                () => { });
        }
    }

    getData() {
        this.setState({ loading: true });
        this.props.setResultsRequestParams(REGISTRY.aml, null);

        if (this.props.asReport === true) {
            apiGet(`${window.babylonApiUrl}/api/search/aml/request-po/report/${this.props.match.params.id}`, null,
                (res) => {
                    this.onSuccess(res.data);
                    this.setState({ dataHash: getDataHash(res.data) })
                },
                () => { })
        } else {
            apiGet(`${window.babylonApiUrl}/api/search/aml/request-po/${this.props.match.params.id}`, null, (res) => this.onSuccess(res.data), () => { })
        }
    }

    areAvailable = (data) => data.reportStatus === amlReportStatus.available;

    onSuccess = (data) => {
        this.setState({ data: data, loading: false });

        if (!isNullOrUndefined(data)) {
            if (this.props.asReport === true) {
                this.props.setResultsRequestParams(REGISTRY.aml,
                    this.areAvailable(data) ? { subPath: 'request-po', id: parseInt(this.props.match.params.id), params: { asReport: this.props.asReport === true } } : null
                );
            } else {
                this.props.setResultsRequestParams(REGISTRY.aml, { subPath: 'request-po', id: parseInt(this.props.match.params.id), params: null });
            }
        }
    }

    getSearchData() {
        return {
            ico: this.state.data.basicInformations.companyId,
            country: this.state.data.country,
            amlTree: hasPermission(null, "AMLPathToBeneficialUser") ? this.state.amlTree : false,
            share: this.state.data.share
        };
    }

    isPath = () => this.state.amlTree && hasPermission(null, "AMLPathToBeneficialUser");

    updateData() {
        //in this function, AmlCompany partially works instead of the AmlPath component,
        //because only after checking the amlTree checkbox (this.state.amlTree), we know whether it is a company or a path request
        var generatedDataForServer = this.getSearchData();
        apiPost(
            `${window.babylonApiUrl}/api/search/aml/check/${this.isPath() ? 'path' : 'po'}`,
            null,
            generatedDataForServer,
            (res) => {
                if (res.data.isSuccess) {
                    generatedDataForServer.oldRequestDate = res.data.requestDate;

                    if (this.props.asReport && isNullOrUndefined(res.data.id)) {
                        this.confirmationPopupNewRequest(generatedDataForServer, res.data, true);
                        return;
                    }

                    if (isNullOrUndefined(res.data.id))
                        this.confirmationPopup();
                    else {
                        const path = `/search/aml/results/${this.isPath() ? 'path' : 'company'}/${res.data.id}`;
                        if (res.data.isCustomerRequest)
                            this.decisionPopup(generatedDataForServer, res.data.requestDateFormatted, path);
                        else
                            this.props.history.push(path);
                    }
                }
                else
                    this.onError(res.data);
            },
            (err) => this.onError(err.data)
        );
    }

    confirmationPopupNewRequest = (values, amlCheckData, forceNewRequest = false) => {
        this.props.showPopup('ceeConfirmation', {
            title: this.props.translate('Search.Common.Warning'),
            open: true,
            style: { display: "block", flex: "initial" },
            close: () => { this.props.hidePopup(); },
            no: () => this.props.hidePopup(),
            yes: () => this.initiateRequest(),
            formData: { // it is needed to take into account that all sections (fo, po, fpo) are under the single form - for example it is needed to prevent
                // from showing company name field from 'po' section in 'fo' section confirmation dialog
                birthId: undefined,
                fullName: undefined,
                birthDate: undefined,
                birthYear: undefined,
                ico: values.ico,
                address: this.state.selected !== SEARCH_TYPE.fo || values.address.trim() === '' ? undefined : values.address.trim(),
                companyName: this.state.selected !== SEARCH_TYPE.po || values.companyName.trim() === '' ? undefined : values.companyName.trim(),
                businessName: this.state.selected !== SEARCH_TYPE.fpo || values.businessName.trim() === '' ? undefined : values.businessName.trim(),
                firstName: undefined,
                surname: undefined,
                middleName: undefined,
                notFound: false,
                isFop: false,
                city: undefined,
                gender: undefined,
                country: values.country,
                trialFileNumber: undefined
            },
            requestType: SEARCH_TYPE.po,
            registry: REGISTRY.aml,
            amlCheck: {
                isSuccess: amlCheckData.isSuccess,
                accountType: amlCheckData.accountType,
                disponible: amlCheckData.disponible,
                amount: amlCheckData.amount
            }

        });
    }

    confirmationPopup() {
        this.props.showPopup('updateAmlData', {
            open: true,
            close: () => this.props.hidePopup(),
            onSubmitAmlRequest: () => this.initiateRequest(),
            data: this.state.data,
            asCompany: true
        });
    }

    initiateRequest() {
        var searchData = this.getSearchData();
        searchData.forceNewRequest = true;
        this.props.initiateCeeRequestOnPo(REGISTRY.aml, REGISTRY.aml, searchData);
        this.setState({ refreshReqInit: true });
    }

    decisionPopup = (generatedDataForServer, requestDate, continuePath) => {
        this.props.showPopup('ceeDecision', {
            title: this.props.translate('Common.Information'),
            open: true,
            close: () => { this.props.hidePopup(); },
            requestDate: requestDate,
            continue: () => {
                //re-use the old request  
                if (!isNullOrUndefined(continuePath) && continuePath !== '')
                    this.props.history.push(continuePath);
                else
                    this.props.hidePopup();
            },
            newRequest: () => {
                this.props.hidePopup();
                generatedDataForServer.forceNewRequest = true;
                //check credit to get accurate price and create a new request
                apiPost(
                    `${window.babylonApiUrl}/api/search/aml/check/${this.isPath() ? 'path' : 'po'}`,
                    null,
                    generatedDataForServer,
                    (res) => {
                        if (res.data.isSuccess) {
                            if (isNullOrUndefined(res.data.requestId))
                                this.confirmationPopup();
                            else
                                this.props.history.push(continuePath);
                        } else
                            this.onError(res.data);
                    },
                    (err) => this.onError(err.data)
                );
            }
        });
    }

    onError = (data) => this.setState({ responseData: data });

    renderErrors = () => {
        const resData = this.props.cee[REGISTRY.aml].responseData;
        const stateResData = this.state.responseData;

        if (this.props.cee[REGISTRY.aml].requestResult === false && this.hasError(resData) || this.hasError(stateResData)) {
            return (
                <div style={{ marginTop: "1em" }}>
                    {((!isNullOrUndefined(resData) && !isNullOrUndefined(resData.exception)) || (!isNullOrUndefined(stateResData) && !isNullOrUndefined(stateResData.exception))) &&
                        <Message type="error" message="">
                            {!isNullOrUndefined(stateResData) && !!stateResData.exception
                                ? <Translate options={{ renderInnerHtml: true }} id={stateResData.exception} data={isNullOrUndefined(stateResData.exceptionData) ? undefined : stateResData.exceptionData} />
                                : <Translate options={{ renderInnerHtml: true }} id={resData.exception} data={isNullOrUndefined(resData.exceptionData) ? undefined : resData.exceptionData} />}
                        </Message>}

                    {((!isNullOrUndefined(resData) && !!resData.error) || (!isNullOrUndefined(stateResData) && !!stateResData.error)) &&
                        <Message type="error" message="">
                            {!isNullOrUndefined(stateResData) && !!stateResData.error
                                ? <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(stateResData.error.message) ? stateResData.error : stateResData.error.message} />
                                : <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(resData.error.message) ? resData.error : resData.error.message} />}
                        </Message>}
                </div>
            );
        }
    }

    hasError = (data) => !isNullOrUndefined(data) && (!isNullOrUndefined(data.exception) || !isNullOrUndefined(data.errorFile) || !!data.error);
}

export default withLocalize(connect(
    state => { return { cee: state.registrySearch, user: state.userContext } },
    dispatch => bindActionCreators({ ...registrySearchActions, ...popupActions }, dispatch)
)(AmlCompany));
